var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedEventOverViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2081 11.125H10.964L16.4544 16.6808C16.6643 16.8931 17.0096 16.9104 17.2254 16.7047C18.5699 15.4229 19.4948 13.6949 19.7661 11.7525C19.8127 11.4199 19.5399 11.125 19.2081 11.125ZM18.6581 8.84683C18.3719 4.64701 15.0553 1.29096 10.9049 1.00127C10.5881 0.979123 10.3212 1.24948 10.3212 1.57081V9.43746H18.0957C18.4132 9.43746 18.68 9.16745 18.6581 8.84683ZM8.65358 11.125V2.78266C8.65358 2.44691 8.36209 2.17093 8.03377 2.21804C3.89346 2.81008 0.728724 6.47024 0.876034 10.8567C1.02751 15.3617 4.8607 19.056 9.31474 18.9994C11.0658 18.9772 12.6838 18.4063 14.0141 17.4514C14.2885 17.2545 14.3066 16.8457 14.0686 16.6048L8.65358 11.125Z",
    fill: "#9999CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedEventOverViewIcon);
export default __webpack_public_path__ + "static/media/unSelectedEventOverViewIcon.bc16635e13381e99d2cbdeeb3aa7e9f8.svg";
export { ForwardRef as ReactComponent };